module.exports = __webpack_public_path__ + "static/jacob-0902c6f4d066180e9bef55cec229e161.jpg";